<template>
	<div :class="className">
		<div v-for="n in lines" :key="n" :class="`${className}__line`" />
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	props: {
		lines: {
			type: Number,
			default: 4,
		},
	},

	setup() {
		return {
			className: 'vue-content-placeholders-text',
		};
	},
});
</script>
